import { createAnimation } from './mixins'

export const fadeIn = createAnimation('fadeIn', {
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
})

export const fadeOut = createAnimation('fadeOut', {
  '0%': {
    opacity: 1,
  },
  '100%': {
    opacity: 0,
  },
})

export const pulse = (scale: number) =>
  createAnimation('pulse', {
    '0%': {
      transform: 'scale3d(1)',
    },
    '60%': {
      transform: `scale3d(${scale}, ${scale}, 1)`,
    },
    '100%': {
      transform: 'scale3d(1)',
    },
  })

export const slideIn = createAnimation('slideIn', {
  '0%': {
    transform: 'translate(100%)',
  },
  '100%': {
    transform: 'translate(0%)',
  },
})

export const slideOut = createAnimation('slideOut', {
  '0%': {
    transform: 'translate(0%)',
  },
  '100%': {
    transform: 'translate(100%)',
  },
})

export const errorShake = createAnimation('errorShake', {
  '0%': { transform: ' translate(0px)' },
  '20%': { transform: 'translate(-30px)' },
  '40%': { transform: 'translate(15px)' },
  '60%': { transform: 'translate(-15px)' },
  '80%': { transform: 'translate(8px)' },
  '100%': { transform: 'translate(0px)' },
})
